export {default as InputSmall} from './InputSmall'



// WEBPACK FOOTER //
// ./src/components/inputs/InputSmall/index.js